import { formatHHmmDDMMYYYY } from "../../utils/format"
import { statusCheckInStorage } from "../../utils/mapping"

export function transferStatus(arrs,sourceAction) {
  let response = []
  var actions = arrs.map(action => {
    return {
      ...action,
      modifiedAtDisplay: formatHHmmDDMMYYYY(action.modifiedAt),
      actionName: statusCheckInStorage(action.processorStatus)?.text
    }
  })
  const checkCancel = actions.find(action => action.processorStatus === 'CANCELED')
  response = actions
  if (sourceAction == 'MANUAL') {
    if (actions.length === 1) {
      response = actions.concat([
        {
          actionName: 'Đang nhập kho',
          processorStatus: 'PROCESSING',
          orderStatus: 'PROCESSING'
        },
        {
          actionName: 'Hoàn thành',
          processorStatus: 'SUCCESS',
          orderStatus: 'SUCCESS'
        }
      ])
    } else if (actions.length === 2) {
      if (checkCancel) {
        return actions
      } else {
        const result = actions.concat([{
            actionName: 'Hoàn thành',
            processorStatus: 'SUCCESS',
            orderStatus: 'SUCCESS'
          }])
        response = result.map(re => {
          if (re.processorStatus === 'PROCESSING') {
            return {
              ...re,
              modifiedAtDisplay: ''
            }
          } else {
            return re
          }
        })
      }
    } else {
      if (checkCancel) {
        response = actions
      } else {
        const checkDraft = actions.find(action => action.processorStatus === 'DRAFT')
        const checkProcess = actions.find(action => action.processorStatus === 'PROCESSING')
        const checkSuccess = actions.find(action => action.processorStatus === 'SUCCESS')
        response = [checkDraft, {...checkProcess, actionName: 'Nhập kho' }, checkSuccess]
      }
    }
  } else if (sourceAction == "RETURN") {
    if (actions.length === 1) {
      response = actions.concat([
        {
          actionName: 'Đang tiến hành',
          processorStatus: 'DRAFT',
          orderStatus: 'DRAFT'
        },
        {
          actionName: 'Nhập hàng',
          processorStatus: 'PROCESSING',
          orderStatus: 'PROCESSING'
        },
        {
          actionName: 'Hoàn thành',
          processorStatus: 'SUCCESS',
          orderStatus: 'SUCCESS'
        }
      ])
    } else if (actions.length === 2) {
      if (checkCancel) {
        return actions
      } else {
        const result = actions.concat([{
            actionName: 'Hoàn thành',
            processorStatus: 'SUCCESS',
            orderStatus: 'SUCCESS'
          }])
        response = result.map(re => {
          if (re.processorStatus === 'DRAFT') {
            return {
              ...re,
              actionName: 'Đang tiến hành'
            }
          };
          if (re.processorStatus === 'PROCESSING') {
            return {
              ...re,
              actionName: 'Nhập hàng',
              modifiedAtDisplay: ''
            }
          } else {
            return re
          }
        })
      }
    } else {
      if (checkCancel) {
        response = actions
      } else {
        const checkDraft = actions.find(action => action.processorStatus === 'DRAFT')
        checkDraft.actionName = 'Đang tiến hành';
        const checkProcess = actions.find(action => action.processorStatus === 'PROCESSING')
        checkProcess.actionName = 'Nhập hàng';
        const checkSuccess = actions.find(action => action.processorStatus === 'SUCCESS')
        response = [checkDraft, {...checkProcess, actionName: 'Nhập hàng' }, checkSuccess]
      }
    }
  }
  return response
}

export function transferStatus2(arrs, type) {
  let response = []
  var actions = arrs.map(action => {
    return {
      ...action,
      modifiedAtDisplay: formatHHmmDDMMYYYY(action.modifiedAt),
      actionName: statusCheckInStorage(action.orderStatus)?.text
    }
  })
  const checkCancel = actions.find(action => action.processorStatus === 'CANCELED')
  response = actions
  if (actions.length === 1) {
    response = actions.concat([
      {
        actionName: 'Đang nhập kho',
        processorStatus: 'PROCESSING',
        orderStatus: 'PROCESSING'
      },
      {
        actionName: 'Hoàn thành',
        processorStatus: 'SUCCESS',
        orderStatus: 'SUCCESS'
      }
    ])
  } else if (actions.length === 2) {
    if (checkCancel) {
      return actions
    } else {
      const result = actions.concat([{
          actionName: 'Hoàn thành',
          processorStatus: 'SUCCESS',
          orderStatus: 'SUCCESS'
        }])
      response = result.map(re => {
        if (re.orderStatus === 'PROCESSING') {
          return {
            ...re,
            modifiedAtDisplay: ''
          }
        } else {
          return re
        }
      })
    }
  } else {
    if (checkCancel) {
      response = actions
    } else {
      const checkDraft = actions.find(action => action.orderStatus === 'DRAFT')
      const checkProcess = actions.find(action => action.orderStatus === 'PROCESSING')
      const checkSuccess = actions.find(action => action.orderStatus === 'SUCCESS')
      if(type == true){
        response = [checkDraft, {...checkProcess, actionName: 'Xuất kho', modifiedAtDisplay: checkSuccess.modifiedAtDisplay }, checkSuccess]
      }else{
        response = [checkDraft, {...checkProcess, actionName: 'Nhập kho', modifiedAtDisplay: checkSuccess.modifiedAtDisplay }, checkSuccess]
      }
      
    }
  }
  return response
}